import React from "react";
import phone from "./Images/phone.svg";
import location from "./Images/location.svg";
import email from "./Images/email.svg";
import "./css/Footer.css";
export const Footer = () => {
  return (
    <>
      <footer className="bg-[#67C6E6] text-white footer md:text-xl md:py-10 md:px-20 px-6 py-10 mt-10">
        <div className="">
          <div className="mx-auto flex flex-col md:flex-row justify-between md:items-center space-y-8 md:space-y-0">
            <div className="flex flex-col md:space-y-4 space-y-2 text-left">
              <a href="#" className="hover:underline">
                Home
              </a>
              <a href="#" className="hover:underline">
                About
              </a>
              <a href="#" className="hover:underline">
                Services
              </a>
            </div>
            <div className="hidden md:block border-r h-40"></div>
            <div className="flex flex-col md:space-y-4 space-y-2 text-left">
              <a href="#" className="hover:underline">
                Privacy Policy
              </a>
              <a href="#" className="hover:underline">
                Support
              </a>
              <a href="#" className="hover:underline">
                Terms & conditions
              </a>
            </div>
            <div className="hidden md:block border-r h-40"></div>
            <div className="flex flex-col md:space-y-4 space-y-2 text-left">
              <div className="flex items-center space-x-2">
                <img alt="email" src={email} className="md:w-6 w-5 icon" />
                <span>bgsarbannidhi@gmail.com</span>
              </div>
              <div className="flex items-center space-x-2">
                <img alt="phone" src={phone} className="md:w-6 w-5 icon" />
                <span>9405555855, 8668777355</span>
              </div>
              <div className="flex items-center space-x-2">
                <img
                  alt="location"
                  src={location}
                  className="md:w-6 w-5 icon"
                />
                <span>Pune, India</span>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
